import { createContext } from 'react';

const ReportContext = createContext();
export default ReportContext;